import React, {Component} from 'react';
import getGatewayContent from '../lib/gatewayContent';
import {getFptiEventForFormSubmit} from '../lib/analytics-helper';
import getHTMLElement from '../lib/setHtmlHelper';
import axios from 'axios';
import pardotFormConfig from '../lib/pardotFormConfig';
import loadable from '@loadable/component';
import brcClientConstants from '../lib/brcClientConstants.js';
import deserializeJSON from '../lib/jsonUtils';

const IframeProcessor = loadable(() => import('../lib/IframeProcessor'));
const { ENTERPRISE_SOLUTIONS_NAVIGATING_NEW_ERA_PAYMENTS,
  ENTERPRISE_SOLUTIONS_MERCATOR_STUDY,
  GUIDE_TO_EFFECTIVE_ONLINE_PAYMENTS,
  ENTERPRISE_SOLUTIONS_NEW_PAYMENTS_PROCESSOR,
  ENTERPRISE_UCC_JUNE_2021,
  FIELDS_CLASSES: { ERROR_MSG, VX_HAS_ERROR }, FIELDS_ATTRIBUTES: {
    ARIA_INVALID
  } } = brcClientConstants;

class GatewayDownload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      urlPath: '',
      firstname: '',
      cookies: '',
      lastname: '',
      email: '',
      company: '',
      monthlysalesvolume: '',
      annualsalesvolume: '',
      website: '',
      businessphone: '',
      title: '',
      countryCode: '',
      dropshipper: '',
      country: this.props.country.toLowerCase(),
      legalCheckbox: false,
      businessneeds: '',
      installment: '',
      Shoppingcartsystem: '',
      PaymentAgency: '',
      DescriptionQuestions: '',
      PaypalbusinessAccount: ''
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePdf = this.handlePdf.bind(this);
    this.toggle = this.toggle.bind(this);
    this.createPardotForm = this.createPardotForm.bind(this);
  }

  componentDidMount() {
    if (this.props.pdfKey === 'Y') {
      window.sessionStorage.setItem('slugId', this.props.slugId);
      window.sessionStorage.setItem('countryName', this.props.country.toLowerCase());
      window.sessionStorage.setItem('localeName', this.props.locale);
    } else {
      window.sessionStorage.setItem('slugId', '');
      window.sessionStorage.setItem('countryName', '');
      window.sessionStorage.setItem('localeName', '');
    }
    this.setState({
      urlPath: window.location.href,
      cookies: document.cookie,
    });
  }

  handleChange(e) {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  toggle() {
    this.setState({
      legalCheckbox: !this.state.legalCheckbox,
    });
  }

  createPardotForm(pardotConfigObject) {
    const pardotForm = [];
    pardotConfigObject.forEach((formObject) => {
      const {country = '', slugIds = [], link = '', local = ''} = formObject;
      if (slugIds && slugIds.length === 1) {
        let key = '';
        key = local !== '' ? `${country}-${slugIds[0]}-${local}` : `${country}-${slugIds[0]}`;
        const data = {[key]: link};
        pardotForm.push(data);
      } else {
        const subArr = slugIds && slugIds.map((val) => {
          let key = '';
          key = local !== '' ? `${country}-${val}-${local}` : `${country}-${val}`;
          return {
            [key]: link
          };
        });
        pardotForm.push(...subArr);
      }
    });
    return pardotForm;
  }

  handleSubmit(e) {
    e.preventDefault();
    const {
      firstname,
      lastname,
      email,
      company,
      website,
      businessphone,
      countryCode,
      title,
      dropshipper,
      installment,
      country,
      Shoppingcartsystem,
      PaypalbusinessAccount,
    } = this.state;
    const monthlysalesvolume =
      this.state.monthlysalesvolume !== ''
        ? this.state.monthlysalesvolume
        : this.state.annualsalesvolume;
    let {legalCheckbox} = this.state;
    const alphaExp =
      /^[ÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜäëïöü¡¿çÇßØøÅåÆæÞþÐð""\D\s-'.,&amp;#@:?!()$\/]+(\s{0,1}[ÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜäëïöü¡¿çÇßØøÅåÆæÞþÐð""\D\s-'.,&amp;#@:?!()$\/])*$/;
    const emailExp =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([ÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜäëïöü¡¿çÇßØøÅåÆæÞþÐð""\D\s-'.,&amp;#@:?!()$\/]+\.)+[a-zA-Z]{2,}))$/;
    const businessEmail =
      /^((?!(@yahoo\.com|outlook\.com|@gmail\.com|hotmail\.com|qq\.com)).)*$/g;
    // const websiteExp = /^(http(s)?:\/\/)?(www\.)?[ÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜäëïöü¡¿çÇßØøÅåÆæÞþÐð""\w\d\s-'.,&amp;#@:?!()$\/]+([\-\.]{1}[ÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜäëïöü¡¿çÇßØøÅåÆæÞþÐð""\w\d\s-'.,&amp;#@:?!()$\/]+)*\.[ÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜäëïöü¡¿çÇßØøÅåÆæÞþÐð""\D\s-'.,&amp;#@:?!()$\/]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
    const websiteExp =
      /^(http(s)?:\/\/)?(www\.)?.+([\-\.]{1}.+)*\..{2,5}(:[0-9]{1,5})?(\/.*)?$/;
    const numberExp = /^([0-9]{6,25})$/;
    const countryCodeExp = /^(\+?\d{1,2}|\d{1,3})$/;
    // const companyExp = /^([ÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜäëïöü¡¿çÇßØøÅåÆæÞþÐð""\w\d\s-'.,&amp;#@:?!()$\/])*$/;
    const websiteLower = website.toLowerCase();
    const content = getGatewayContent(this.state.country, this.props.slugId);
    const hidefieldsMx =
      this.state.country === 'mx' &&
      this.props.slugId === ENTERPRISE_SOLUTIONS_NAVIGATING_NEW_ERA_PAYMENTS;
    const error = [];

    const enterpriseSlugs = [
      ENTERPRISE_SOLUTIONS_MERCATOR_STUDY,
      GUIDE_TO_EFFECTIVE_ONLINE_PAYMENTS,
      ENTERPRISE_SOLUTIONS_NEW_PAYMENTS_PROCESSOR,
      ENTERPRISE_UCC_JUNE_2021,
      ENTERPRISE_SOLUTIONS_NAVIGATING_NEW_ERA_PAYMENTS,
      'SFCC-2021',
    ];
    const enterpriseArticle = enterpriseSlugs.includes(this.props.slugId);

    const emailCheck = enterpriseArticle
      ? email.match(emailExp) && email.match(businessEmail)
      : email.match(emailExp);

    if (firstname === '') {
      document.getElementById('errMsg_firstName').innerHTML =
        content && content.firstNameRequired;
      document.getElementById('errMsg_firstName').className = ERROR_MSG;
      document
        .getElementById('gateway_firstName')
        .classList.add(VX_HAS_ERROR);
      document
        .getElementById('gateway_firstName')
        .setAttribute(ARIA_INVALID, 'true');
      if (this.state.country === 'br') {
        error.push(content && content.firstNameRequired);
      } else {
        error.push(`First Name : ${content && content.firstNameRequired}`);
      }
    }
    if (firstname !== '') {
      document.getElementById('errMsg_firstName').innerHTML = '';
      document.getElementById('errMsg_firstName').className = '';
      if (!firstname.match(alphaExp)) {
        document.getElementById('errMsg_firstName').innerHTML =
          content && content.firstNameError;
        document.getElementById('errMsg_firstName').className = ERROR_MSG;
        document
          .getElementById('gateway_firstName')
          .classList.add(VX_HAS_ERROR);
        document
          .getElementById('gateway_firstName')
          .setAttribute(ARIA_INVALID, 'true');
        error.push(content.firstNameError);
      }
      if (firstname.match(alphaExp)) {
        document.getElementById('errMsg_firstName').innerHTML = '';
        document.getElementById('errMsg_firstName').className = '';
        document
          .getElementById('gateway_firstName')
          .classList.remove(VX_HAS_ERROR);
        document
          .getElementById('gateway_firstName')
          .setAttribute(ARIA_INVALID, 'false');
      }
    }
    if (lastname === '') {
      document.getElementById('errMsg_lastName').innerHTML =
        content.lastNameRequired;
      document.getElementById('errMsg_lastName').className = ERROR_MSG;
      document.getElementById('gateway_lastName').classList.add(VX_HAS_ERROR);
      document
        .getElementById('gateway_lastName')
        .setAttribute(ARIA_INVALID, 'true');
      if (this.state.country === 'br') {
        error.push(content && content.lastNameRequired);
      } else {
        error.push(`Last Name : ${content && content.lastNameRequired}`);
      }
    }
    if (lastname !== '') {
      document.getElementById('errMsg_lastName').innerHTML = '';
      document.getElementById('errMsg_lastName').className = '';
      if (!lastname.match(alphaExp)) {
        document.getElementById('errMsg_lastName').innerHTML =
          content.lastNameError;
        document.getElementById('errMsg_lastName').className = ERROR_MSG;
        document
          .getElementById('gateway_lastName')
          .classList.add(VX_HAS_ERROR);
        document
          .getElementById('gateway_lastName')
          .setAttribute(ARIA_INVALID, 'true');
        error.push(content.lastNameError);
      }
      if (lastname.match(alphaExp)) {
        document.getElementById('errMsg_lastName').innerHTML = '';
        document.getElementById('errMsg_lastName').className = '';
        document
          .getElementById('gateway_lastName')
          .classList.remove(VX_HAS_ERROR);
        document
          .getElementById('gateway_lastName')
          .setAttribute(ARIA_INVALID, 'false');
      }
    }

    if (email === '') {
      document.getElementById('errMsg_email').innerHTML = content.emailRequired;
      document.getElementById('errMsg_email').className = ERROR_MSG;
      document.getElementById('gateway_email').classList.add(VX_HAS_ERROR);
      document
        .getElementById('gateway_email')
        .setAttribute(ARIA_INVALID, 'true');
      if (this.state.country === 'br') {
        error.push(content && content.emailRequired);
      } else {
        error.push(`Email : ${content && content.emailRequired}`);
      }
    }
    if (email !== '') {
      if (email.match(emailExp)) {
        if (enterpriseArticle && !email.match(businessEmail)) {
          document.getElementById('errMsg_email').innerHTML =
            content.emailDomainError;
          document.getElementById('errMsg_email').className = ERROR_MSG;
          document
            .getElementById('gateway_email')
            .classList.add(VX_HAS_ERROR);
          document
            .getElementById('gateway_email')
            .setAttribute(ARIA_INVALID, 'true');
          error.push(content.emailDomainError);
        } else {
          document.getElementById('errMsg_email').innerHTML = '';
          document.getElementById('errMsg_email').className = '';
          document
            .getElementById('gateway_email')
            .classList.remove(VX_HAS_ERROR);
          document
            .getElementById('gateway_email')
            .setAttribute(ARIA_INVALID, 'false');
        }
      } else {
        document.getElementById('errMsg_email').innerHTML = content.emailError;
        document.getElementById('errMsg_email').className = ERROR_MSG;
        document.getElementById('gateway_email').classList.add(VX_HAS_ERROR);
        document
          .getElementById('gateway_email')
          .setAttribute(ARIA_INVALID, 'true');
        error.push(content.emailError);
      }
    }

    if (company === '' && !hidefieldsMx) {
      document.getElementById('errMsg_company').innerHTML =
        content.companyNameRequired;
      document.getElementById('errMsg_company').className = ERROR_MSG;
      document.getElementById('gateway_company').classList.add(VX_HAS_ERROR);
      document
        .getElementById('gateway_company')
        .setAttribute(ARIA_INVALID, 'true');
      if (this.state.country === 'br') {
        error.push(content && content.companyNameRequired);
      } else {
        error.push(`Company Name : ${content && content.companyNameRequired}`);
      }
    }
    if (company !== '') {
      document.getElementById('errMsg_company').innerHTML = '';
      document.getElementById('errMsg_company').className = '';
      document
        .getElementById('gateway_company')
        .classList.remove(VX_HAS_ERROR);
      document
        .getElementById('gateway_company')
        .setAttribute(ARIA_INVALID, 'false');    
    }

    if (!hidefieldsMx) {
      if (monthlysalesvolume === '') {
        document.getElementById('errMsg_monthlysalesvolume').innerHTML =
          content.salesvolumeRequired;
        document.getElementById('errMsg_monthlysalesvolume').className =
          ERROR_MSG;
        document
          .getElementById('gateway_monthlysalesvolume')
          .classList.add(VX_HAS_ERROR);
        document
          .getElementById('gateway_monthlysalesvolume')
          .setAttribute(ARIA_INVALID, 'true');
        if (this.state.country === 'br') {
          error.push(content && content.salesvolumeRequired);
        } else {
          error.push(
            `Monthly Sales Volume : ${content && content.salesvolumeRequired}`
          );
        }
      } else {
        document.getElementById('errMsg_monthlysalesvolume').innerHTML = '';
        document.getElementById('errMsg_monthlysalesvolume').className = '';
        document
          .getElementById('gateway_monthlysalesvolume')
          .classList.remove(VX_HAS_ERROR);
        document
          .getElementById('gateway_monthlysalesvolume')
          .setAttribute(ARIA_INVALID, 'false');
      }
    }

    if (websiteLower === '') {
      document.getElementById('errMsg_website').innerHTML =
        content.companyWebsiteRequired;
      document.getElementById('errMsg_website').className = ERROR_MSG;
      document.getElementById('gateway_website').classList.add(VX_HAS_ERROR);
      document
        .getElementById('gateway_website')
        .setAttribute(ARIA_INVALID, 'true');
      if (this.state.country === 'br') {
        error.push(content && content.companyWebsiteRequired);
      } else {
        error.push(
          `Company Website : ${content && content.companyWebsiteRequired}`
        );
      }
    }
    if (websiteLower !== '') {
      document.getElementById('errMsg_website').innerHTML = '';
      document.getElementById('errMsg_website').className = '';
      if (!websiteLower.match(websiteExp)) {
        document.getElementById('errMsg_website').innerHTML =
          content.companyWebsiteError;
        document.getElementById('errMsg_website').className = ERROR_MSG;
        document
          .getElementById('gateway_website')
          .classList.add(VX_HAS_ERROR);
        document
          .getElementById('gateway_website')
          .setAttribute(ARIA_INVALID, 'true');
        error.push(content.companyWebsiteError);
      }
      if (websiteLower.match(websiteExp)) {
        document.getElementById('errMsg_website').innerHTML = '';
        document.getElementById('errMsg_website').className = '';
        document
          .getElementById('gateway_website')
          .classList.remove(VX_HAS_ERROR);
        document
          .getElementById('gateway_website')
          .setAttribute(ARIA_INVALID, 'false');
      }
    }
    if (!enterpriseArticle && countryCode === '') {
      document.getElementById('errMsg_countryCode').innerHTML =
        content.coutryCodeRequired;
      document.getElementById('errMsg_countryCode').className = ERROR_MSG;
      document
        .getElementById('gateway_countryCode')
        .classList.add(VX_HAS_ERROR);
      document
        .getElementById('gateway_countryCode')
        .setAttribute(ARIA_INVALID, 'true');
      document.getElementById('create_space').innerHTML = '<br/>';
      if (this.state.country === 'br') {
        error.push(content && content.coutryCodeRequired);
      } else {
        error.push(`Country Code : ${content && content.coutryCodeRequired}`);
      }
    }

    if (countryCode !== '') {
      document.getElementById('errMsg_countryCode').innerHTML = '';
      document.getElementById('errMsg_countryCode').className = '';
      if (countryCode.match(countryCodeExp)) {
        document.getElementById('errMsg_countryCode').innerHTML = '';
        document.getElementById('errMsg_countryCode').className = '';
        document
          .getElementById('gateway_countryCode')
          .classList.remove(VX_HAS_ERROR);
        document
          .getElementById('gateway_countryCode')
          .setAttribute(ARIA_INVALID, 'false');
      } else {
        document.getElementById('errMsg_countryCode').innerHTML =
          content.coutryCodeError;
        document.getElementById('errMsg_countryCode').className =
          ERROR_MSG;
        document
          .getElementById('gateway_countryCode')
          .classList.add(VX_HAS_ERROR);
        document
          .getElementById('gateway_countryCode')
          .setAttribute(ARIA_INVALID, 'true');
        document.getElementById('create_space').innerHTML = '<br/>';
        error.push(content.coutryCodeError);
      }
    }
    if (businessphone === '') {
      document.getElementById('errMsg_businessphone').innerHTML =
        content.phoneRequired;
      document.getElementById('errMsg_businessphone').className =
        ERROR_MSG;
      document
        .getElementById('gateway_businessphone')
        .classList.add(VX_HAS_ERROR);
      document
        .getElementById('gateway_businessphone')
        .setAttribute(ARIA_INVALID, 'true');
      if (this.state.country === 'br') {
        error.push(content && content.phoneRequired);
      } else {
        error.push(`Business Phone : ${content && content.phoneRequired}`);
      }
    }
    if (businessphone !== '') {
      document.getElementById('errMsg_businessphone').innerHTML = '';
      document.getElementById('errMsg_businessphone').className = '';
      if (businessphone.match(numberExp)) {
        document.getElementById('errMsg_businessphone').innerHTML = '';
        document.getElementById('errMsg_businessphone').className = '';
        document
          .getElementById('gateway_businessphone')
          .classList.remove(VX_HAS_ERROR);
        document
          .getElementById('gateway_businessphone')
          .setAttribute(ARIA_INVALID, 'false');
      } else {
        document.getElementById('errMsg_businessphone').innerHTML =
          content.phoneError;
        document.getElementById('errMsg_businessphone').className =
          ERROR_MSG;
        document
          .getElementById('gateway_businessphone')
          .classList.add(VX_HAS_ERROR);
        document
          .getElementById('gateway_businessphone')
          .setAttribute(ARIA_INVALID, 'true');
        error.push(content.phoneError);
      }
    }

    if (gatewayInfo && gatewayInfo['job-title']) {
      if (title === '') {
        document.getElementById('errMsg_jobTitle').innerHTML =
          content.jobTitleRequired;
        document.getElementById('errMsg_jobTitle').className = ERROR_MSG;
        document
          .getElementById('gateway_jobTitle')
          .classList.add(VX_HAS_ERROR);
        document
          .getElementById('gateway_jobTitle')
          .setAttribute(ARIA_INVALID, 'true');
        if (this.state.country === 'br') {
          error.push(content && content.jobTitleRequired);
        } else {
          error.push(`Job Title : ${content && content.jobTitleRequired}`);
        }
      } else {
        document.getElementById('errMsg_jobTitle').innerHTML = '';
        document.getElementById('errMsg_jobTitle').className = '';
        document
          .getElementById('gateway_jobTitle')
          .classList.remove(VX_HAS_ERROR);
        document
          .getElementById('gateway_jobTitle')
          .setAttribute(ARIA_INVALID, 'false');
      }
    }
    if (this.props.slugId === 'SFCC-2021' && country === 'jp') {
      if (Shoppingcartsystem === '') {
        document.getElementById('errMsg_shoppingCart').innerHTML = content.shoppingCartRequired;
        document.getElementById('errMsg_shoppingCart').className = ERROR_MSG;
        document.getElementById('gateway_shopping_cart_system').classList.add(VX_HAS_ERROR);
        document.getElementById('gateway_shopping_cart_system').setAttribute(ARIA_INVALID, 'true');
        error.push(content.shoppingCartRequired);
      } else {
        document.getElementById('errMsg_shoppingCart').innerHTML = '';
        document.getElementById('errMsg_shoppingCart').className = '';
        document.getElementById('gateway_shopping_cart_system').classList.remove(VX_HAS_ERROR);
        document.getElementById('gateway_shopping_cart_system').setAttribute(ARIA_INVALID, 'false');
      }
      if (PaypalbusinessAccount === '') {
        document.getElementById('errMsg_PP_account').innerHTML = content.businessAccountRequired;
        document.getElementById('errMsg_PP_account').className = ERROR_MSG;
        document.getElementById('gateway_PP_account').classList.add(VX_HAS_ERROR);
        document.getElementById('gateway_PP_account').setAttribute(ARIA_INVALID, 'true');
      } else if (content.businessAccountRequired) {
        document.getElementById('errMsg_PP_account').innerHTML = '';
        document.getElementById('errMsg_PP_account').className = '';
        document.getElementById('gateway_PP_account').classList.remove(VX_HAS_ERROR);
        document.getElementById('gateway_PP_account').setAttribute(ARIA_INVALID, 'false');
      }
    }
    if (gatewayInfo && gatewayInfo['dropshipper-field'] === 'Y') {
      if (dropshipper === '') {
        document.getElementById('errMsg_dropShipper').innerHTML =
          content.dropShipperRequired;
        document.getElementById('errMsg_dropShipper').className =
          ERROR_MSG;
        document
          .getElementById('gateway_dropShipper')
          .classList.add(VX_HAS_ERROR);
        document
          .getElementById('gateway_dropShipper')
          .setAttribute(ARIA_INVALID, 'true');
        error.push(`Drop Shipper : ${content && content.dropShipperRequired}`);
      } else {
        document.getElementById('errMsg_dropShipper').innerHTML = '';
        document.getElementById('errMsg_dropShipper').className = '';
        document
          .getElementById('gateway_dropShipper')
          .classList.remove(VX_HAS_ERROR);
        document
          .getElementById('gateway_dropShipper')
          .setAttribute(ARIA_INVALID, 'false');
      }
    }

    if (!content.showLegalCheckbox) {
      legalCheckbox = true;
    }

    if (!legalCheckbox) {
      document.getElementById('errChk').innerHTML = content.selectCheckbox;
      document.getElementById('errChk').className = ERROR_MSG;
      document
        .getElementById('field_checkBox')
        .setAttribute(ARIA_INVALID, 'true');
      error.push(content.selectCheckbox);
    } else {
      document.getElementById('errChk').innerHTML = '';
      document.getElementById('errChk').className = '';
      document
        .getElementById('field_checkBox')
        .setAttribute(ARIA_INVALID, 'false');
    }
    if (!hidefieldsMx) {
      if (
        installment === '' &&
        (country === 'mx' || country === 'br') &&
        content.provideInstalmentsTitle
      ) {
        document.getElementById('errMsg_installment').innerHTML =
          content.selectRadioCheckbox;
        document.getElementById('errMsg_installment').className =
          ERROR_MSG;
        document
          .getElementById('gateway_installment')
          .classList.add(VX_HAS_ERROR);
        document
          .getElementById('gateway_installment')
          .setAttribute(ARIA_INVALID, 'true');
      } else if (content.provideInstalmentsTitle) {
        document.getElementById('errMsg_installment').innerHTML = '';
        document.getElementById('errMsg_installment').className = '';
        document
          .getElementById('gateway_installment')
          .classList.remove(VX_HAS_ERROR);
        document
          .getElementById('gateway_installment')
          .setAttribute(ARIA_INVALID, 'false');
      }
    }

    if (error.length > 0) {
      getFptiEventForFormSubmit(
        this.state.country,
        this.props.locale,
        content && content.eloquaFormName,
        'Error',
        error[0],
        'brcArticle',
        'download-gateway-form:' + this.props.slugId,
        this.props.userAccountInfo,
        this.props.encryptedAccountNumber,
        this.state.cookies && this.state.cookies.includes('isFormSubmitted')
      );
    }
    const jobTitleCondition =
      gatewayInfo && gatewayInfo['job-title'] ? title !== '' : true;
    const dropShipperCondition =
      gatewayInfo && gatewayInfo['dropshipper-field'] === 'Y'
        ? dropshipper !== ''
        : true;
    const installmentMandatory =
      !hidefieldsMx &&
      installment === '' &&
      country === 'mx' &&
      content.provideInstalmentsTitle
        ? false
        : true;
    const checkmonthlysalesvolume = hidefieldsMx
      ? true
      : monthlysalesvolume !== '';
    //only validate for JP - 'SFCC-2021'
    const shoppingCartMandatory = country === 'jp' && this.props.slugId === 'SFCC-2021' && Shoppingcartsystem === '' ? false : true;
    const PaypalbusinessAccountMandatory = country === 'jp' && this.props.slugId === 'SFCC-2021' && PaypalbusinessAccount === '' ? false : true;
    const isFormReady = enterpriseArticle
      ? firstname.match(alphaExp) &&
      lastname.match(alphaExp) &&
      emailCheck &&
      checkmonthlysalesvolume &&
      websiteLower.match(websiteExp) &&
      businessphone.match(numberExp) &&
      jobTitleCondition &&
      dropShipperCondition &&
      legalCheckbox &&
      installmentMandatory &&
      shoppingCartMandatory &&
      PaypalbusinessAccountMandatory
      : firstname.match(alphaExp) &&
      lastname.match(alphaExp) &&
      emailCheck &&
      monthlysalesvolume !== '' &&
      websiteLower.match(websiteExp) &&
      countryCode.match(countryCodeExp) &&
      businessphone.match(numberExp) &&
      jobTitleCondition &&
      dropShipperCondition &&
      legalCheckbox &&
      installmentMandatory;
    if (isFormReady) {
      const gateWayForm = document.getElementById(
        content && content.eloquaFormName
      );
      getFptiEventForFormSubmit(
        this.state.country,
        this.props.locale,
        content && content.eloquaFormName,
        'Success',
        'form_validation',
        'brcArticle',
        'download-gateway-form:' + this.props.slugId,
        this.props.userAccountInfo,
        this.props.encryptedAccountNumber,
        this.state.cookies && this.state.cookies.includes('isFormSubmitted')
      );
      axios
        .get('/brc/getPDFUrl', {
          params: {
            slugID: this.props.slugId,
          },
        })
        .then(function (response) {
          const gatewayInfo = deserializeJSON(response.data.results);
          gateWayForm.action = content.pardotActionUrl
            ? content.pardotActionUrl
            : 'https://s94483084.t.eloqua.com/e/f2';
          gateWayForm.method = 'POST';
          gateWayForm.submit();
          document.cookie = 'isFormSubmitted=true';
          window.open(gatewayInfo['pdf-link'], '_blank');
        })
        .catch(function (error) {
          console.log('error', error.message);
        });
    }
  }

  handlePdf(e) {
    e.preventDefault();
    const self = this;
    axios
      .get('/brc/getPDFUrl', {
        params: {
          slugID: this.props.slugId,
        },
      })
      .then(function (response) {
        const gatewayInfo = deserializeJSON(response.data.results);
        const pdfURL = gatewayInfo['pdf-link'];
        const appendHttp = `https://${pdfURL}`;
        const content = getGatewayContent(self.state.country);
        if (pdfURL.substring(0, 4) === 'http') {
          window.open(pdfURL, '_blank');
        } else {
          window.open(appendHttp, '_blank');
        }
        getFptiEventForFormSubmit(
          self.state.country,
          self.props.locale,
          content && content.eloquaFormName,
          'Success',
          'form_validation',
          'brcArticle',
          'download-gateway:' + self.props.slugId,
          self.props.userAccountInfo,
          self.props.encryptedAccountNumber,
          self.state.cookies && self.state.cookies.includes('isFormSubmitted')
        );
      })
      .catch(function (error) {
        console.log('error', error.message);
      });
  }

  render() {
    const country = this.state.country;
    const content = getGatewayContent(country, this.props.slugId);
    const params = this.state.urlPath && this.state.urlPath.split('?');
    const utmvalues = params[params.length - 1];
    const values = utmvalues && utmvalues.split('&');
    const gclid =
      values &&
      values.length > 0 &&
      values.filter((s) => s.indexOf('gclid') > -1)[0];
    const utmgclid = gclid && gclid.indexOf('=');
    const gclidValue = gclid && gclid.substring(utmgclid + 1, utmgclid.length);
    const utmcampaign =
      values &&
      values.length > 0 &&
      values.filter((s) => s.indexOf('utm_campaign') > -1)[0];
    const utmcampaignValue = utmcampaign && utmcampaign.indexOf('=');
    const campaignValue =
      utmcampaign &&
      utmcampaign.substring(utmcampaignValue + 1, utmcampaign.length);
    const utmMedium =
      values &&
      values.length > 0 &&
      values.filter((s) => s.indexOf('utm_medium') > -1)[0];
    const utmMediumValue = utmMedium && utmMedium.indexOf('=');
    const meduimValue =
      utmMedium && utmMedium.substring(utmMediumValue + 1, utmMedium.length);
    const utmContent =
      values &&
      values.length > 0 &&
      values.filter((s) => s.indexOf('utm_content') > -1)[0];
    const utmContentValue = utmContent && utmContent.indexOf('=');
    const contentValue =
      utmContent &&
      utmContent.substring(utmContentValue + 1, utmContent.length);
    const utmSource =
      values &&
      values.length > 0 &&
      values.filter((s) => s.indexOf('utm_source') > -1)[0];
    const utmsourceValue = utmSource && utmSource.indexOf('=');
    const sourceValue =
      utmSource && utmSource.substring(utmsourceValue + 1, utmSource.length);
    const fbReturnCheck = contentValue && contentValue === 'leadgen';
    const gatewayInfo = this.props.gatewayInfo;
    const salesVolume =
      gatewayInfo &&
      gatewayInfo['saves-volume-options'] &&
      gatewayInfo['saves-volume-options'].split('|');
    const jobTitle =
      gatewayInfo &&
      gatewayInfo['job-title'] &&
      gatewayInfo['job-title'].split('|');
    const hidefieldsMx =
      this.state.country === 'mx' &&
      this.props.slugId === ENTERPRISE_SOLUTIONS_NAVIGATING_NEW_ERA_PAYMENTS;
    const enterpriseSlugs = [
      ENTERPRISE_SOLUTIONS_MERCATOR_STUDY,
      GUIDE_TO_EFFECTIVE_ONLINE_PAYMENTS,
      ENTERPRISE_SOLUTIONS_NEW_PAYMENTS_PROCESSOR,
      ENTERPRISE_UCC_JUNE_2021,
      ENTERPRISE_SOLUTIONS_NAVIGATING_NEW_ERA_PAYMENTS,
      'SFCC-2021',
    ];
    const pardotFormLists = this.createPardotForm(pardotFormConfig);
    const enterpriseArticle = enterpriseSlugs.includes(this.props.slugId);
    if (fbReturnCheck) {
      document.cookie = 'isFormSubmitted=true';
    }
    const cookieAvailable =
      (this.state.cookies && this.state.cookies.includes('isFormSubmitted')) ||
      fbReturnCheck;
    if (content && this.props.pdfKey === 'Y') {
      const key = this.props.attachUrl !== '' ? `${country}-${this.props.slugId}-${this.props.locale.toUpperCase()}` : `${country}-${this.props.slugId}`;
      const selectedFormObj = pardotFormLists.length !== 0 ? pardotFormLists.find((item) => item[key]) : '';
      const url = selectedFormObj !== undefined && selectedFormObj !== '' ? selectedFormObj[key] : undefined;

      let pardotURL = undefined;
      if (this.props.gatewayPatdotUrl !== undefined) {
        pardotURL = this.props.gatewayPatdotUrl;
      } else {
        pardotURL = url;
      }
      if (pardotURL) {
        return (
          <div
            className="gatewayMainContainer"
            style={{
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            <IframeProcessor
              className="pardotFormIframe"
              customStyle={{border: '2px solid #003087', borderRadius: '10px'}}
              countryCode={this.props.country.toUpperCase()}
              content={{
                pardotUrl: pardotURL,
                iframeTitle: 'pardot-brc-form-gateway'
              }}
              userType={this.props.userAccountInfo}
              encryptedAccountNumber={this.props.encryptedAccountNumber}
            />
          </div>
        );
      } else {
        return (
          <div className="gatewayMainContainer">
            {gatewayInfo &&
            ((!cookieAvailable &&
              (gatewayInfo['new-user-title'] ||
                gatewayInfo['pdf-_description'] ||
                gatewayInfo['image-link'])) ||
              gatewayInfo['existing-user-title']) ? (
              <div className="headSection">
                <div className="textSection">
                  {(gatewayInfo && gatewayInfo['new-user-title']) ||
                  (gatewayInfo && gatewayInfo['existing-user-title']) ? (
                    <h1>
                      {cookieAvailable
                        ? gatewayInfo && gatewayInfo['existing-user-title']
                        : gatewayInfo && gatewayInfo['new-user-title']}
                    </h1>
                  ) : (
                    ''
                  )}
                  {gatewayInfo && gatewayInfo['pdf-_description'] ? (
                    <h4>
                      {getHTMLElement(
                        gatewayInfo && gatewayInfo['pdf-_description'],
                        {useHTML: true}
                      )}
                    </h4>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            ) : (
              ''
            )}
            <div className="formSection">
              {cookieAvailable || fbReturnCheck ? (
                <div>
                  <div className="downloadBtn-container">
                    <input
                      type="submit"
                      value={gatewayInfo && gatewayInfo['download-button-text']}
                      className="pypl-btn cookieBtn"
                      onClick={this.handlePdf}
                    />
                  </div>
                </div>
              ) : (
                <div>
                  <p>{gatewayInfo && gatewayInfo['form-fields-title']}</p>
                  <form
                    id={content && content.eloquaFormName}
                    method="post"
                    name={content && content.eloquaFormName}
                    onSubmit={this.handleSubmit}
                  >
                    {content.pardotActionUrl ? null : (
                      <React.Fragment>
                        <input
                          value={content && content.eloquaFormName}
                          type="hidden"
                          name="elqFormName"
                        />
                        <input
                          value="94483084"
                          type="hidden"
                          name="elqSiteId"
                        />
                        <input
                          value={this.state.urlPath}
                          type="hidden"
                          name="eloquaRedirectUrl"
                        />
                        <input name="elqCampaignId" type="hidden"/>
                      </React.Fragment>
                    )}
                    <input
                      value={gclidValue ? gclidValue : ''}
                      type="hidden"
                      id="gclid"
                      name="gclid"
                    />
                    <input
                      value={campaignValue ? campaignValue : ''}
                      type="hidden"
                      id="utm_campaign"
                      name="utm_campaign"
                    />
                    <input
                      value={sourceValue ? sourceValue : 'direct'}
                      type="hidden"
                      id="utm_source"
                      name="utm_source"
                    />
                    <input
                      value={meduimValue ? meduimValue : 'web-brc'}
                      type="hidden"
                      id="utm_medium"
                      name="utm_medium"
                    />
                    <input
                      value={contentValue ? contentValue : ''}
                      type="hidden"
                      id="utm_content"
                      name="utm_content"
                    />
                    <div
                      style={{
                        position: 'absolute',
                        left: '-9999px',
                        top: '-9999px',
                      }}
                    >
                      <label htmlFor="pardot_extra_field">Comments</label>
                      <input
                        type="text"
                        id="pardot_extra_field"
                        name="pardot_extra_field"
                        aria-hidden={'true'}
                      />
                    </div>
                    <input
                      id="gateway_country"
                      name="country"
                      type="hidden"
                      value={country.toUpperCase()}
                    />
                    <div className="inputfields">
                      <div className="firstForm">
                        {content.orderLastBeforeFirst !== null &&
                        content.orderLastBeforeFirst ? (
                          <React.Fragment>
                            <div className="formFields">
                              <label
                                htmlFor="gateway_lastName"
                                className="visuallyhidden visuallyhidden-white"
                              >
                                {'Last Name'}
                              </label>
                              <input
                                id="gateway_lastName"
                                name="lastname"
                                aria-describedby="errMsg_lastName"
                                placeholder={content && content.lastName}
                                maxLength="100"
                                type="textarea"
                                value={this.state.lastname}
                                onChange={this.handleChange}
                                className="form-control vx_form-control inputEmail"
                              />
                              <span id="errMsg_lastName"/>
                            </div>
                            <div className="formFields">
                              <label
                                htmlFor="gateway_firstName"
                                className="visuallyhidden visuallyhidden-white"
                              >
                                {'First Name'}
                              </label>
                              <input
                                id="gateway_firstName"
                                name="firstname"
                                aria-describedby="errMsg_firstName"
                                placeholder={content && content.firstName}
                                maxLength="100"
                                type="textarea"
                                value={this.state.firstname}
                                onChange={this.handleChange}
                                className="form-control vx_form-control inputEmail"
                              />
                              <span id="errMsg_firstName"/>
                            </div>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <div className="formFields">
                              <label
                                htmlFor="gateway_firstName"
                                className="visuallyhidden visuallyhidden-white"
                              >
                                {'First Name'}
                              </label>
                              <input
                                id="gateway_firstName"
                                name="firstname"
                                aria-describedby="errMsg_firstName"
                                placeholder={content && content.firstName}
                                maxLength="100"
                                type="textarea"
                                value={this.state.firstname}
                                onChange={this.handleChange}
                                className="form-control vx_form-control inputEmail"
                              />
                              <span id="errMsg_firstName"/>
                            </div>
                            <div className="formFields">
                              <label
                                htmlFor="gateway_lastName"
                                className="visuallyhidden visuallyhidden-white"
                              >
                                {'Last Name'}
                              </label>
                              <input
                                id="gateway_lastName"
                                name="lastname"
                                aria-describedby="errMsg_lastName"
                                placeholder={content && content.lastName}
                                maxLength="100"
                                type="textarea"
                                value={this.state.lastname}
                                onChange={this.handleChange}
                                className="form-control vx_form-control inputEmail"
                              />
                              <span id="errMsg_lastName"/>
                            </div>
                          </React.Fragment>
                        )}

                        <div className="formFields">
                          <label
                            htmlFor="gateway_email"
                            className="visuallyhidden visuallyhidden-white"
                          >
                            {'Busines Email'}
                          </label>
                          <input
                            id="gateway_email"
                            name="email"
                            aria-describedby="errMsg_email"
                            placeholder={content && content.email}
                            maxLength="100"
                            type="textarea"
                            value={this.state.email}
                            onChange={this.handleChange}
                            className="form-control vx_form-control inputEmail"
                          />
                          <span id="errMsg_email"/>
                          <span id="create_space"/>
                        </div>
                        {!hidefieldsMx && (
                          <div className="formFields">
                            <label
                              htmlFor="gateway_company"
                              className="visuallyhidden visuallyhidden-white"
                            >
                              {'Company Name'}
                            </label>
                            <input
                              id="gateway_company"
                              name="company"
                              aria-describedby="errMsg_company"
                              placeholder={content && content.companyName}
                              maxLength="100"
                              type="textarea"
                              value={this.state.company}
                              onChange={this.handleChange}
                              className="form-control vx_form-control inputEmail"
                            />
                            <span id="errMsg_company"/>
                          </div>
                        )}
                        {gatewayInfo &&
                        gatewayInfo['dropshipper-field'] === 'Y' ? (
                          <div className="radioButtons">
                            <fieldset className="ppvx_radio-group">
                              <p className="dropShipperText">
                                Does your company run a drop shipping business?
                              </p>
                              <div className="radioOptions">
                                <div className="radioOptionYes">
                                  <input
                                    type="radio"
                                    name="dropshipper"
                                    id="gateway_dropShipper"
                                    aria-describedby="radio_helper-message"
                                    value="Yes"
                                    checked={this.state.dropshipper == 'Yes'}
                                    onChange={this.handleChange}
                                  />
                                  <label>Yes</label>
                                </div>
                                <div className="radioOptionNo">
                                  <input
                                    type="radio"
                                    name="dropshipper"
                                    aria-describedby="radio_helper-message"
                                    id="gateway_dropShipper"
                                    value="No"
                                    checked={this.state.dropshipper == 'No'}
                                    onChange={this.handleChange}
                                  />
                                  <label htmlFor="radio-button-16">No</label>
                                </div>
                              </div>
                            </fieldset>
                            <span id="errMsg_dropShipper"/>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className="secondForm">
                        <label
                          htmlFor="gateway_monthlysalesvolume"
                          className="visuallyhidden visuallyhidden-white"
                        >
                          {'Monthly Online Sales Volume'}
                        </label>
                        {!hidefieldsMx && (
                          <div className="formFields ppvx_dropdown">
                            <select
                              id="gateway_monthlysalesvolume"
                              name={
                                (enterpriseArticle && country === 'in') ||
                                (enterpriseArticle && country === 'jp')
                                  ? 'annualsalesvolume'
                                  : 'monthlysalesvolume'
                              }
                              onChange={this.handleChange}
                              className="form-control vx_form-control ppvx_dropdown__control"
                              value={this.state.montlySalesValues}
                            >
                              <optgroup label={content && content.mothlySales}>
                                <option value="">
                                  {content && content.selectOne}
                                </option>
                                {salesVolume && salesVolume.length > 0
                                  ? salesVolume.map((value, index) => {
                                    return (
                                      <option key={index} value={value}>
                                        {' '}
                                        {value}{' '}
                                      </option>
                                    );
                                  })
                                  : ''}
                              </optgroup>
                            </select>
                            <label className="ppvx_dropdown__label">
                              {content && content.mothlySales}
                            </label>
                            <span id="errMsg_monthlysalesvolume"/>
                          </div>
                        )}
                        <div className="formFields">
                          <label
                            htmlFor="gateway_website"
                            className="visuallyhidden visuallyhidden-white"
                          >
                            {'Company Website'}
                          </label>
                          <input
                            id="gateway_website"
                            name="website"
                            aria-describedby="errMsg_website"
                            placeholder={content && content.companyWebsite}
                            maxLength="256"
                            type="textarea"
                            value={this.state.website}
                            onChange={this.handleChange}
                            className="form-control vx_form-control inputEmail"
                          />
                          <span id="errMsg_website"/>
                        </div>
                        <div className="phoneNumber">
                          {enterpriseArticle ? (
                            ''
                          ) : (
                            <div className="formFields countryCode">
                              <label
                                htmlFor="gateway_countryCode"
                                className="visuallyhidden visuallyhidden-white"
                              >
                                {'Country Code'}
                              </label>
                              <input
                                id="gateway_countryCode"
                                name="countryCode"
                                aria-describedby="errMsg_countryCode"
                                placeholder={content && content.countryCode}
                                type="textarea"
                                value={this.state.countryCode}
                                onChange={this.handleChange}
                                className="form-control vx_form-control inputEmail"
                              />
                              <span id="errMsg_countryCode"/>
                            </div>
                          )}
                          <div className="formFields phnNum">
                            <label
                              htmlFor="gateway_businessphone"
                              className="visuallyhidden visuallyhidden-white"
                            >
                              {'Phone'}
                            </label>
                            <input
                              id="gateway_businessphone"
                              name="businessphone"
                              aria-describedby="errMsg_businessphone"
                              placeholder={content && content.busPhone}
                              maxLength="25"
                              type="textarea"
                              value={this.state.businessphone}
                              onChange={this.handleChange}
                              className="form-control vx_form-control inputEmail"
                            />
                            <span id="errMsg_businessphone"/>
                          </div>
                        </div>
                        {gatewayInfo && gatewayInfo['job-title'] ? (
                          <div className="formFields ppvx_dropdown">
                            <select
                              id="gateway_jobTitle"
                              name="title"
                              onChange={this.handleChange}
                              className="form-control vx_form-control ppvx_dropdown__control"
                              value={this.state.jobTitle}
                            >
                              <optgroup label={content && content.jobTitle}>
                                <option value="">
                                  {content && content.selectOne}
                                </option>
                                {jobTitle && jobTitle.length > 0
                                  ? jobTitle.map((value, index) => {
                                    return (
                                      <option key={index} value={value}>
                                        {' '}
                                        {value}{' '}
                                      </option>
                                    );
                                  })
                                  : ''}
                              </optgroup>
                            </select>
                            <label
                              className="ppvx_dropdown__label"
                              htmlFor="gateway_jobTitle"
                            >
                              {content && content.jobTitle}
                            </label>
                            <span id="errMsg_jobTitle"/>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                    {' '}
                    {this.props.slugId === 'SFCC-2021' ?
                      <div className="thirdForm">
                        <div className="formFields ppvx_dropdown">
                          <select id="gateway_shopping_cart_system" name="Shoppingcartsystem"
                            onChange={this.handleChange}
                            className="form-control vx_form-control ppvx_dropdown__control"
                            value={this.state.Shoppingcartsystem}>
                            <optgroup label={content && content.shoppingCart}>
                              <option value="">{content && content.selectOne}</option>
                              {content.shoppingCartOption.map((value, index) => {
                                return (
                                  <option key={index} value={value}> {value} </option>
                                );
                              })}
                            </optgroup>
                          </select>
                          <label className="ppvx_dropdown__label" htmlFor="gateway_shopping_cart_system">
                            {content && content.shoppingCart}
                          </label>
                          <span id="errMsg_shoppingCart"/>
                        </div>
                        <div className="formFields">
                          <label htmlFor="gateway_payment_processor" className="visuallyhidden visuallyhidden-white">
                            {'Payment Processor'}
                          </label>
                          <input id="gateway_payment_processor" name="PaymentAgency"
                            aria-describedby="errMsg_payment_processor"
                            placeholder={content.paymentServiceProvider} maxLength="500" type="textarea"
                            value={this.state.paymentServiceProvider} onChange={this.handleChange}
                            className="form-control vx_form-control inputEmail"/>
                          <span id="errMsg_payment_processor"/>
                        </div>
                        <div className="formFields">
                          <label htmlFor="gateway_any_question" className="visuallyhidden visuallyhidden-white">
                            {'Describe Your Questions'}
                          </label>
                          <input id="gateway_any_question" name="DescriptionQuestions"
                            aria-describedby="errMsg_description_questions" placeholder={content.showQuestionBox}
                            maxLength="500" type="textarea" value={this.state.questionDescription}
                            onChange={this.handleChange} className="form-control vx_form-control inputEmail"/>
                          <span id="errMsg_paymentProcessor"/>
                        </div>
                        <div className="radioButtons">
                          <fieldset className="ppvx_radio-group">
                            <p className="showBusinessAccount">
                              {content.showBusinessAccount}
                            </p>
                            <div className="radioOptions">
                              <div className="radioOptionYes">
                                <input
                                  type="radio"
                                  name="PaypalbusinessAccount"
                                  id="gateway_PP_account"
                                  aria-describedby="radio_helper-message"
                                  value="Yes"
                                  checked={this.state.PaypalbusinessAccount == 'Yes'}
                                  onChange={this.handleChange}
                                />
                                <label>
                                  {content.businessAccountYes}
                                </label>
                              </div>
                              <div className="radioOptionNo">
                                <input
                                  type="radio"
                                  name="PaypalbusinessAccount"
                                  aria-describedby="radio_helper-message"
                                  id="gateway_PP_account"
                                  value="No"
                                  checked={this.state.PaypalbusinessAccount == 'No'}
                                  onChange={this.handleChange}
                                />
                                <label htmlFor="radio-button-16">
                                  {content.businessAccountNo}
                                </label>
                              </div>
                            </div>
                          </fieldset>
                          <span id="errMsg_PP_account"/>
                        </div>
                      </div>
                      : ''}
                    {content.provideInstalmentsTitle && !hidefieldsMx ? (
                      <div className="radioButtons">
                        <fieldset className="ppvx_radio-group">
                          <p className="provideInstallmentText">
                            {content.provideInstalmentsTitle}
                          </p>
                          <div className="radioOptions">
                            <div className="radioOptionYes">
                              <input
                                type="radio"
                                name="installment"
                                id="gateway_installment"
                                aria-describedby="radio_helper-message"
                                value="Yes"
                                checked={this.state.installment == 'Yes'}
                                onChange={this.handleChange}
                              />
                              <label>{content.provideInstalmentsYes}</label>
                            </div>
                            <div className="radioOptionNo">
                              <input
                                type="radio"
                                name="installment"
                                aria-describedby="radio_helper-message"
                                id="gateway_installment"
                                value="No"
                                checked={this.state.installment == 'No'}
                                onChange={this.handleChange}
                              />
                              <label htmlFor="radio-button-16">
                                {content.provideInstalmentsNo}
                              </label>
                            </div>
                          </div>
                        </fieldset>
                        <span id="errMsg_installment"/>
                      </div>
                    ) : (
                      ''
                    )}
                    {content.showBusinessNeeds ? (
                      <div className="formFields">
                        <label
                          htmlFor="gateway_business_needs"
                          className="visuallyhidden visuallyhidden-white"
                        >
                          {'Tell us your business needs'}
                        </label>
                        <input
                          id="gateway_business_needs"
                          name="businessneeds"
                          aria-describedby="errMsg_business_needs"
                          placeholder={
                            content && content.showBusinessNeedsLabel
                          }
                          maxLength="500"
                          type="textarea"
                          value={this.state.businessneeds}
                          onChange={this.handleChange}
                          className="form-control vx_form-control inputEmail"
                        />
                        <span id="errMsg_website"/>
                      </div>
                    ) : (
                      ''
                    )}
                    <div className="vx_form-group_hiddenLabel legalContainer">
                      <label
                        htmlFor="field_checkBox"
                        className="label-position top visuallyhidden-white"
                      >
                        {'Checkbox'}
                      </label>
                      <span id="errChk"/>
                      <input
                        id="field_checkBox"
                        name={
                          content.showBusinessNeeds ? 'agreepolicy' : 'OptIn'
                        }
                        aria-describedby="errChk"
                        type="checkbox"
                        value={
                          content.showBusinessNeeds
                            ? 'Y'
                            : this.state.legalCheckbox
                        }
                        onClick={this.toggle}
                        className={`legalCheckbox ${
                          content.showLegalCheckbox ? '' : 'visuallyhidden'
                        }`}
                      />
                      <span className="legalCopy">
                        {
                          ('*',
                            getHTMLElement(
                              gatewayInfo && gatewayInfo['privacy-message'],
                              {useHTML: true}
                            ))
                        }
                      </span>
                    </div>
                    {gatewayInfo ? (
                      <div className="downloadBtn-container">
                        <input
                          type="submit"
                          value={
                            gatewayInfo && gatewayInfo['download-button-text']
                          }
                          className="pypl-btn downloadBtn"
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </form>
                </div>
              )}
            </div>

            {this.props.slugId === 'borderless-commerce' ||
            this.props.slugId === 'international-selling-strategy' ||
            this.props.slugId === 'borderless-commerce-1' ? (
              <div className="microsite">
                <p>
                  {content && content.textBeforeLink}
                  <a
                    href="https://www.paypal-borderlesscommerce.com/"
                    target="_blank"
                    className="micrositeData"
                  >
                    {content && content.linkText}
                  </a>
                  {content && content.textAfterLink}
                </p>
              </div>
            ) : (
              ''
            )}

            {this.props.slugId === 'digitise-thrive' ? (
              <div className="microsite">
                <br/>
                <h4>
                  <b>{content && content.startSellingHeader}</b>
                </h4>
                <p>{content && content.startSellingBody}</p>
                {country === 'hk' || country === 'sg' ? (
                  <a
                    href={`https://www.paypal.com/${country}/business`}
                    target="_blank"
                  >
                    Learn More
                  </a>
                ) : (
                  ''
                )}
              </div>
            ) : (
              ''
            )}
          </div>
        );
      }
    }  else    {
      return null;
    }
  }
}

export default GatewayDownload;
